import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    modal: {},
};
const slice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        openModal(state, { payload }) {
            state.modal.type = payload.type;
            state.modal.title = payload.title;
            state.modal.body = payload.body;
            state.modal.show = true;
            console.log(state.modal);
        },
        closeModal(state) {
            state.modal = {};
            state.modal.show = false;
        },
    },
});
export const notification = {
    reducer: slice.reducer,
    mutation: slice.actions,
};
